import { useEffect } from "react";
import { dismissFloatingLayers } from "../dismissFloatingLayers";

function useOverlayLifecycle(open: boolean, onClose?: () => void) {
  useEffect(() => {
    if (!open || typeof document === "undefined") {
      return;
    }

    const originalOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";
    dismissFloatingLayers();

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        onClose?.();
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose, open]);
}

export { useOverlayLifecycle };
